import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};

  p {
    font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    line-height: ${props => props.theme.texts.bodyMRegular.lineHeight};
    color: ${props => props.theme.colors.black};
    margin: 0;

    strong {
      font-family: ${props => props.theme.texts.bodyMBold.fontFamily};
    }
  }

  p:first-child {
    font-family: ${props => props.theme.texts.titleS.fontFamily};
    font-size: ${props => props.theme.texts.titleS.fontSize};
    line-height: ${props => props.theme.texts.titleS.lineHeight};
    color: ${props => props.theme.colors.black};
  }
`
